import React from 'react';
import CustomContainer from '../../components/CustomContainer';
import { useNavigate, useParams } from 'react-router-dom';
import CardForm from '../../components/form/CardForm';
import { fields } from './PriceListFormConfig';

const PriceListPage = (props) => {
  let { id } = useParams();

  const navigate = useNavigate();

  return (
    <>
      <CustomContainer title={id ? 'Cennik' : 'Nowy cennik'}>
        <>
          <CardForm
            id={id}
            key={id}
            postSaved={(saved) => navigate(`/price-list/${saved.id}`)}
            title={'Cennik'}
            fields={fields}
            api={'price-list'}
            shadow={false}
            trick="W przypadku konfliktu współczynników, priorytet mają te ustawione dla wybranych dni. System zawsze zastosuje wartość z konkretnej daty, ignorując współczynnik dnia tygodnia."
            width={8}
          />
        </>
      </CustomContainer>
    </>
  );
};

export default PriceListPage;
